import React from 'react'

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	loading?: boolean
	loadingText?: string
	spinnerClassName?: string
}

/**
 * Drop-in replacement for <button>. Adds a spinning icon + optional loading text
 * and disables the button while `loading` is true.
 */
const LoadingButton: React.FC<LoadingButtonProps> = ({
	loading = false,
	loadingText,
	spinnerClassName,
	disabled,
	children,
	className,
	...rest
}) => {
	return (
		<button {...rest} className={className} disabled={disabled || loading}>
			{loading ? (
				<>
					<i className={`ri-loader-4-line animate-spin ${spinnerClassName ?? ''}`} aria-hidden />
					<span className="ms-1">{loadingText ?? children}</span>
				</>
			) : (
				children
			)}
		</button>
	)
}

export default LoadingButton
